module.exports = __webpack_public_path__ + "img/security.045aa31.png";